import { useEffect, useState } from "react";
// ms를 시/분/초로 변환
const msToTime = (ms)=>({
        hours: Math.floor(ms / (1000 * 60 * 60)),
        minutes: Math.floor(ms % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(ms % (1000 * 60) / 1000)
    });
// 오늘 자정(다음날 00:00:00)까지의 시간(ms) 계산
const getMidnightTime = ()=>{
    const now = new Date();
    const midnight = new Date(now);
    midnight.setDate(now.getDate() + 1) // 다음날로 이동
    ;
    midnight.setHours(0, 0, 0, 0) // 자정으로 설정
    ;
    return Math.max(0, midnight.getTime() - now.getTime());
};
const ZERO_TIME = {
    hours: 0,
    minutes: 0,
    seconds: 0
};
/**
 * 종료 시간까지 카운트다운하는 훅
 * @param endTime - 종료 시간 (Date 또는 ISO string, undefined일 경우 오늘 자정까지, null이면 비활성)
 * @param onTimeUp - 시간 종료 시 콜백
 */ export const useCountdown = (endTime, onTimeUp)=>{
    const [timeLeft, setTimeLeft] = useState(()=>{
        if (endTime === null) return ZERO_TIME;
        if (!endTime) {
            // endTime이 없으면 오늘 자정까지
            return msToTime(getMidnightTime());
        }
        const end = typeof endTime === "string" ? new Date(endTime) : endTime;
        const diff = Math.max(0, end.getTime() - Date.now());
        return msToTime(diff);
    });
    useEffect(()=>{
        // null이면 interval 비활성 (불필요한 리렌더 방지)
        if (endTime === null) return;
        const tick = ()=>{
            let diff;
            if (!endTime) {
                // endTime이 없으면 오늘 자정까지
                diff = getMidnightTime();
            } else {
                const end = typeof endTime === "string" ? new Date(endTime) : endTime;
                diff = Math.max(0, end.getTime() - Date.now());
            }
            if (diff === 0) {
                onTimeUp === null || onTimeUp === void 0 ? void 0 : onTimeUp();
                return;
            }
            const next = msToTime(diff);
            setTimeLeft((prev)=>prev.hours === next.hours && prev.minutes === next.minutes && prev.seconds === next.seconds ? prev : next);
        };
        tick();
        const interval = setInterval(tick, 1000);
        return ()=>clearInterval(interval);
    }, [
        endTime,
        onTimeUp
    ]);
    return timeLeft;
};
